module.exports = __webpack_public_path__ + "static/Messaging 3-41b43f53096b4995cd0a0e72ee0d3352.png";